/**
 * Человекочитаемая подпись машины: "2019 Toyota Yaris".
 *
 * Год опционален (#1206 — пустая ячейка в таблице больше не подставляет текущий год),
 * поэтому склеивать через шаблонную строку нельзя: получалось "undefined Toyota Yaris"
 * в контексте для агента, в WhatsApp-сообщении и в описании машины. Эта функция —
 * единственное место, где собирается подпись, чтобы очередная копия не разошлась:
 * до #1206 таких копий было шесть, и часть из них про год просто забыли.
 *
 * @param {{year?: number|null, make?: string|null, model?: string|null}} car
 * @returns {string} подпись без пустых частей и двойных пробелов
 */
export function carTitle(car) {
  if (!car) return '';
  return [car.year, car.make, car.model].filter(Boolean).join(' ');
}
